import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function sendBglXml(
  accountId: string,
  financialYearValue: string,
): Promise<void> {
  try {
    await axios.post(`/accounts/${accountId}/send-epi-xml`, {
      financialYearValue,
    });
    return;
  } catch (error) {
    throw throwSylaApiError(error);
  }
}
